<template>
  <Container type="card-full">
    <div slot="header">
      <!-- <el-button @click="chgPg" :loading="btnLoading">修改</el-button> -->
      <!-- <el-button @click="close">关闭</el-button> -->
    </div>
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">服务类型</div>
          <div class="field">
            <el-select v-model="type.chargefeetype" placeholder="请选择" @change = "search">
              <el-option
                v-for="(item, index) in chargefeetypeList"
                :key="index"
                :label="item.label"
                :value="item.value"
                >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <vggrid :list="list" tableheight="600" flexname="" :cols="cols"
          :showfooter="false" :showPage="false" :resizable="true"
          @cellClick="cellClick"
          :isOperate="btn.isOperate" :operateBtn="btn.right" @vggridClick="vggridClick"
    >
        <template slot="btn">
            <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
        </template>
    </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  export default {
    name: 'pmlbindex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        btnLoading: false,
        btn:{},
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'chargefeebeg', fieldtype: 'I', title: '起始金额',calculExpr:'',addNewRowFlg: false},
          { field: 'chargefeeend', fieldtype: 'I', title: '终止金额',calculExpr:'',addNewRowFlg: false},
          { field: 'chargefeerate', fieldtype: 'I', title: '费率',calculExpr:'',addNewRowFlg: false},
        ],
        pm: {},
        type:{},
        chargefeetypeList:[],  //服务类型
        query:{
          total: 0,
          limit: 20,
          offset: 0
        }
      }
    },
    created () {
      this.$on('CHG', () => this.chgPg())
    },
    activated() {
      this.init()
      if(this.type.chargefeetype){
        this.getPageList()
      }
    },
    mounted () {
      this.getchargefeetypeList()
    },
    watch: {
    },
    components: {MenuBtn,vggrid},
    methods: {
      btnClick (code) {
        this.$emit(code)
      },
      async init() {
        this.list = []
        this.btnLoading = false
      },
      vggridClick(code,row){
        this.pm = row
        this.$emit(code,row)
      },
      btnmenuclick(btn){
        this.btn = btn
      },
      // async close() {
      //   this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      // },
      async chgPg () {
        if (!this.pm.chargefeeid) {
          this.$message.warning('请选择一行!')
          return
        }
        this.$router.push({name: 'pmlbform', params: {form: this.pm, type: 2}})
      },
      async cellClick (row) {
        this.pm = row.row
      },
      async getPageList () {
        this.type.cosid = this.$store.getters.loginUser.cosid
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/basic/pm/getPageList',
          params: this.type
        })
        res.forEach((key)=>{
            key.chargefeebeg = utils.comdify(key.chargefeebeg)
            key.chargefeeend= utils.comdify(key.chargefeeend)
        })
        this.list = res
        this.loading = false
      },
      async getchargefeetypeList () {
        this.chargefeetypeList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'chargefeetype'}
        })
      },
      search () {
        this.getPageList()
      },
    },
    filters: {
    },
    computed: {
    }
  }
</script>
<style lang="scss">

</style>
